export const SMS_CONSENT_ATTESTATION_TEXT = "Mon client m’a donné son accord pour recevoir ces relances par SMS.";
export function normalizeReminderSmsPhone(value) {
    const phone = (value ?? "")
        .replace(/[\s.()-]/g, "")
        .replace(/^0033/, "+33")
        .replace(/^0/, "+33");
    return /^\+33[67]\d{8}$/.test(phone) ? phone : null;
}
//# sourceMappingURL=sms.js.map